import { Step, StepDependencyContext } from "~/components/build/Show/lib/types";
import { create } from "zustand";

interface StepDependenciesStore {
  dependenciesByStep: Record<Step["uuid"], StepDependencyContext>;
  setDependenciesByStep: (dependenciesByStep: Record<Step["uuid"], StepDependencyContext>) => void;
}

/**
 * Store for ephemeral step dependencies-related state.
 */
export const useStepDependenciesStore = create<StepDependenciesStore>()((set, get) => ({
  dependenciesByStep: {},
  setDependenciesByStep: (dependenciesByStep: Record<Step["uuid"], StepDependencyContext>) =>
    set({ dependenciesByStep }),
}));
